// src/utils/brand.js
// The Crazy Pixels logos, served with the portal itself (public/brand/…)
// 3.51.3 (owner, Oct 10): the new "Crazy Pixels" logo (no "Technologies")
// on computers, sign-in and emails; the "Crazy Pixels Fax Portal" logo on
// phones and tablets (it has "Fax Portal" in it, so no title beside it);
// the dots alone in the loading circle. The app icon is in public/icons.
// public/crazypixels-logo.png (the old logo) stays for the fax@ and
// privatefax@ scripts' emails until their next clasp push.
export const LOGO_URL = `${process.env.PUBLIC_URL}/brand/crazy-pixels.png`;
export const LOGO_FAX_PORTAL_URL = `${process.env.PUBLIC_URL}/brand/crazy-pixels-fax-portal.png`;
export const LOGO_DOTS_URL = `${process.env.PUBLIC_URL}/brand/crazy-pixels-dots.png`;
